/**
 * Accessibility for search results.
 * @type {{attach: Drupal.behaviors.searchResults.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const searchResults_once = once('search-results-once', '.view-search-content', context);

    $(searchResults_once).each(function () {
      $(this).find('ul li.views-row').each(function() {
        let $icon = $(this).find('a.content-link i');

        if (($icon.length) && ($icon.hasClass('fa-external-link-alt'))) {
          $icon.append('<span class="visually-hidden">' + Drupal.t("Opens an external page") + '</span>');
        }
      });
    });
  },
}
